import { render, staticRenderFns } from "./ProductRecommendationsSidebar.vue?vue&type=template&id=775e2677&scoped=true&lang=pug&"
import script from "./ProductRecommendationsSidebar.vue?vue&type=script&lang=js&"
export * from "./ProductRecommendationsSidebar.vue?vue&type=script&lang=js&"
import style0 from "./ProductRecommendationsSidebar.vue?vue&type=style&index=0&id=775e2677&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "775e2677",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('775e2677')) {
      api.createRecord('775e2677', component.options)
    } else {
      api.reload('775e2677', component.options)
    }
    module.hot.accept("./ProductRecommendationsSidebar.vue?vue&type=template&id=775e2677&scoped=true&lang=pug&", function () {
      api.rerender('775e2677', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/product/bourdain/ProductRecommendationsSidebar.vue"
export default component.exports